import axios from 'axios'
import { Toast } from 'vant';
import qs from 'qs'
import store from '@/store'
// import { getToken } from '@/utils/auth'

// 创建axios实例
console.log(process.env.NODE_ENV);
// http://192.168.1.57:8009
let baseUrl = process.env.NODE_ENV === 'production' ? 'https://kf.qingruilin.com.cn' : 'https://kf.qingruilin.com.cn'
// let baseUrl = process.env.NODE_ENV === 'production' ? 'http://47.94.195.73:10030' : 'http://47.94.195.73:10030'
console.log(baseUrl)
const service = axios.create({
  baseURL:baseUrl,//http://netbar.htrdit.com  //process.env.VUE_APP_BASE_API // url = base url + request url
  withCredentials: true, // 跨域请求时发送 Cookie
  timeout: 50000 // request timeout
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    if(config.url == '/netbar/api/netbar/v1/del' || config.url == '/netbar/api/customer_management/v1/setAdmin') {
      config.data = {
        ...config.data
      } 
    }else {
      let LoginInfo = JSON.parse(sessionStorage.getItem('loginInfo'))
      if(LoginInfo) {
        let userId = LoginInfo.id
        // 展开数据并且加一个全局
        config.data = {
          ...config.data,
          userId:userId
        } 
      }
    }
    // 修改前后端content-type类型不一样
    config.transformRequest = [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.slice(0, -1) // 去掉最后的空行
        return ret
      }
    ]
    if(config.url == '/netbar/api/common/v1/pic_upload') {
        config.headers['Content-Type'] = 'multipart/form-data'
    }
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // 在发送请求之前执行某些操作
    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
    // console.log('config', config)
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * 如果要获取 http 信息，如标头或状态
   * Please return  response => response
  */

  /**
   * 通过自定义代码确定请求状态
   * 通过 HTTP 状态代码判断状态
   */
  response => {
    const res = response.data
    // 判断状态码，临时注释
    // 如果自定义代码不是 20000，则判断为错误。.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: 非法令牌 50012: 登录的其他客户端; 50014: 令牌已过期;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    return res
    // }
  },
  error => {
    // alert('打印错误信息' + error)
    console.log('err' + error) // for debug
    Toast(error.message)
    return Promise.reject(error)
  }
)

export default service
